import { BaseModelData } from '../base-model-data'

export interface EstimateCategoryData extends BaseModelData {
  name: string
  parentId: string | null
  status: EstimateCategoryStatus
  createdBy?: string | { id: string, name?: string }
  updatedBy?: string | { id: string, name?: string }
}

export enum EstimateCategoryStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
